import React from 'react';

// Simplified silhouettes (pink) used on the Welcome GPT cards
export const AfricaMapIcon = ({ className = 'w-8 h-8' }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true" data-testid="icon-africa-map">
    <path fill="#f472b6" d="M22 18 C32 12 42 10 50 10 C60 10 68 11 72 14 C76 17 78 20 78 24 C82 28 88 34 92 42 C90 48 84 54 80 60 C76 66 74 72 72 78 C66 86 60 92 52 95 C46 92 42 88 40 82 C40 76 42 72 42 68 C42 62 44 58 44 55 C40 53 36 52 34 52 C28 54 20 52 14 50 C8 46 6 42 6 40 C8 34 10 30 12 28 C16 24 18 20 22 18 Z M88 64 C91 68 93 76 90 83 C87 85 84 80 84 74 C84 69 85 65 88 64 Z" />
  </svg>
);

export const GuyaneMapIcon = ({ className = 'w-8 h-8' }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true" data-testid="icon-guyane-map">
    <path fill="#f472b6" d="M30 18 C42 14 58 10 72 12 C76 24 78 42 78 60 C74 72 64 84 50 92 C40 84 30 70 24 56 C20 48 20 36 24 28 C26 22 28 20 30 18 Z" />
  </svg>
);
